// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"235":"b75101c0","656":"6b23fd31"}[chunkId] + ".js";
};